import Constants from "../Constants/Constants";

const API_URL = `${Constants.BASE_URL}/api`;

const API = {
  API_URL,
  members: {
    get login() {
      return {
        url: `${API_URL}/member/login`,
        method: "POST",
      };
    },

    get submitOtp() {
      return {
        url: `${API_URL}/member/verifyloginotp`,
        method: "POST",
      };
    },

    get updateFirstLoginPassword() {
      return {
        url: `${API_URL}/member/updatepasswordfirstlogin`,
        method: "PUT",
      };
    },

    get validateVoucher() {
      return {
        url: `${API_URL}/member/validatevoucher`,
        method: "GET",
      };
    },

    get getAddonsByGroup() {
      return {
        url: `${API_URL}/member/addonbygroup`,
        method: "GET",
      };
    },

    get parkingByGroup() {
      return {
        url: `${API_URL}/member/parkingbygroup`,
        method: "GET",
      };
    },

    get addOrUpgradeParking() {
      return {
        url: `${API_URL}/member/addorupgradeparking`,
        method: "POST",
      };
    },

    get addOrUpgradeAddon() {
      return {
        url: `${API_URL}/member/addorupgradeaddon`,
        method: "POST",
      };
    },

    get upgradePackage() {
      return {
        url: `${API_URL}/member/upgrade`,
        method: "POST",
      };
    },

    get forgotPassword() {
      return {
        url: `${API_URL}/member/forgotpassword`,
        method: "POST",
      };
    },
    get getBuildingsByZipCode() {
      return {
        url: `${API_URL}/member/getzipcodebuildingpackage?zip=`,
        method: "GET",
      };
    },

    get openDoor() {
      return {
        url: `${API_URL}/member/opendoor`,
        method: "POST",
      };
    },

    get addMemberAmenitySlot() {
      return {
        url: `${API_URL}/member/addamenitymemberslot`,
        method: "POST",
      };
    },

    get openGuestDoor() {
      return {
        url: `${API_URL}/member/guestopendoor`,
        method: "POST",
      };
    },

    get resetPassword() {
      return {
        url: `${API_URL}/member/resetpassword`,
        method: "POST",
      };
    },

    get extendBooking() {
      return {
        url: `${API_URL}/booking/extend`,
        method: "POST",
      };
    },

    get getBookingByGuestUuid() {
      return {
        url: `${API_URL}/member/bookingbyuuid?BookingUUid=`,
        method: "GET",
      };
    },

    get guestAmenityAccess() {
      return {
        url: `${API_URL}/member/guestamenities?guestUuid=`,
        method: "GET",
      };
    },

    get addBookingGuest() {
      return {
        url: `${API_URL}/member/addbookingguest`,
        method: "POST",
      };
    },

    get cancelBooking() {
      return {
        url: `${API_URL}/booking/cancelbooking/`,
        method: "POST",
      };
    },

    get signup() {
      return {
        url: `${API_URL}/member/register`,
        method: "POST",
      };
    },
    get signupWithoutPackage() {
      return {
        url: `${API_URL}/member/registerparking`,
        method: "POST",
      };
    },
    get profile() {
      return {
        url: `${API_URL}/member/profile`,
        method: "GET",
      };
    },

    get dashboard() {
      return {
        url: `${API_URL}/member/dashboard`,
        method: "GET",
      };
    },
    get updateProfile() {
      return {
        url: `${API_URL}/member/update-profile`,
        method: "PUT",
      };
    },

    get updatePassword() {
      return {
        url: `${API_URL}/member/update-password`,
        method: "PUT",
      };
    },

    get getUpgradePackagesList() {
      return {
        url: `${API_URL}/member/upgradablepackageslist`,
        method: "GET",
      };
    },

    get getResubscribePackagesList() {
      return {
        url: `${API_URL}/member/resubscribepackageslist`,
        method: "GET",
      };
    },

    get resubscribePackage() {
      return {
        url: `${API_URL}/member/resubscripemembership`,
        method: "POST",
      };
    },

    get cancelSubscription() {
      return {
        url: `${API_URL}/member/cancelsubscription`,
        method: "POST",
      };
    },

    get addCard() {
      return {
        url: `${API_URL}/member/add-card`,
        method: "POST",
      };
    },

    get bookings() {
      return {
        url: `${API_URL}/booking/get-bookings-by-member-id`,
        method: "GET",
      };
    },

    get memberByEmail() {
      return {
        url: `${API_URL}/member/by-email`,
        method: "GET",
      };
    },

    get amenitiesList() {
      return {
        url: `${API_URL}/amenities/get-all-amenities-require-booking`,
        method: "GET",
      };
    },

    get setDefaultCard() {
      return {
        url: `${API_URL}/member/update-card-default`,
        method: "PUT",
      };
    },

    get deleteCard() {
      return {
        url: `${API_URL}/member/deletecard/`,
        method: "DELETE",
      };
    },

    get createBooking() {
      return {
        url: `${API_URL}/booking/create`,
        method: "POST",
      };
    },

    get retrypayment() {
      return {
        url: `${API_URL}/member/retrypayment/`,
        method: "POST",
      };
    },

    get getMemberComplaints() {
      return {
        url: `${API_URL}/assetamenityticket/getbymemberid`,
        method: "GET",
      };
    },

    get addMemberComplaint() {
      return {
        url: `${API_URL}/assetamenityticket/add`,
        method: "POST",
      };
    },
  },

  admin: {
    get getAllGroups() {
      return {
        url: `${API_URL}/admin/group/getallgroups`,
        method: "GET",
      };
    },

    get getGroupById() {
      return {
        url: `${API_URL}/admin/group/getgroupbyid/`,
        method: "GET",
      };
    },

    get getBuildingsByGroupId() {
      return {
        url: `${API_URL}/admin/buildings/getallbygroupid/`,
        method: "GET",
      };
    },

    get getAmenitiesByBuildingId() {
      return {
        url: `${API_URL}/admin/buildings/getamenitiesbybuilding?buildingId=`,
        method: "GET",
      };
    },

    get cancelBooking() {
      return {
        url: `${API_URL}/admin/cancelbooking/`,
        method: "POST",
      };
    },

    get createGroup() {
      return {
        url: `${API_URL}/admin/group/addgroup`,
        method: "POST",
      };
    },

    get updateGroup() {
      return {
        url: `${API_URL}/admin/group/updategroup/`,
        method: "PUT",
      };
    },

    get login() {
      return {
        url: `${API_URL}/admin/login`,
        method: "POST",
      };
    },

    get dashboard() {
      return {
        url: `${API_URL}/admin/dashboard`,
        method: "GET",
      };
    },
    get getAllUsers() {
      return {
        url: `${API_URL}/admin/users`,
        method: "GET",
      };
    },
    get getAllBuildings() {
      return {
        url: `${API_URL}/admin/buildings/getall`,
        method: "GET",
      };
    },

    get getAllMembers() {
      return {
        url: `${API_URL}/admin/member/getall`,
        method: "GET",
      };
    },

    get getAllFreeMembers() {
      return {
        url: `${API_URL}/admin/member/getallfreemembers`,
        method: "GET",
      };
    },

    get checkMemberExist() {
      return {
        url: `${API_URL}/admin/checkmemberemail`,
        method: "POST",
      };
    },

    get addFreeMember() {
      return {
        url: `${API_URL}/admin/savefreemember`,
        method: "POST",
      };
    },

    get getBuildingDataById() {
      return {
        url: `${API_URL}/admin/buildings/getbuildingpackagewithparkingaddon/`,
        method: "GET",
      };
    },

    get getParkingDataByBuildingId() {
      return {
        url: `${API_URL}/admin/parkingByBuilding/`,
        method: "GET",
      };
    },

    get getAllNonMembers() {
      return {
        url: `${API_URL}/admin/nonmember/getall`,
        method: "GET",
      };
    },

    get getMemberById() {
      return {
        url: `${API_URL}/admin/member/`,
        method: "GET",
      };
    },

    get deleteMemberProfile() {
      return {
        url: `${API_URL}/admin/deletememberinformation`,
        method: "POST",
      };
    },

    get getAllFutureBookings() {
      return {
        url: `${API_URL}/admin/bookings`,
        method: "GET",
      };
    },

    get getAllVouchers() {
      return {
        url: `${API_URL}/admin/reports/voucherreport`,
        method: "GET",
      };
    },

    get getProfitQuarterReport() {
      return {
        url: `${API_URL}/admin/buildings/quarterprofitreport`,
        method: "POST",
      };
    },

    get getAllPastBookings() {
      return {
        url: `${API_URL}/admin/bookingreport `,
        method: "GET",
      };
    },

    get getDoorHistory() {
      return {
        url: `${API_URL}/admin/buildings/getbuildingdoorlogbyid?buildingId=`,
        method: "GET",
      };
    },

    get packageSubscriptionReports() {
      return {
        url: `${API_URL}/admin/buildings/packagesubscriptionreport`,
        method: "GET",
      };
    },

    get amenityUsageReport() {
      return {
        url: `${API_URL}/admin/reports/amenityusagereport`,
        method: "POST",
      };
    },

    get buildingMembersReport() {
      return {
        url: `${API_URL}/admin/buildings/buildingmemberreport`,
        method: "GET",
      };
    },

    get profitReport() {
      return {
        url: `${API_URL}/admin/buildings/ownerprofitreport`,
        method: "GET",
      };
    },

    get residentReports() {
      return {
        url: `${API_URL}/admin/buildings/residentreport`,
        method: "GET",
      };
    },

    get addMember() {
      return {
        url: `${API_URL}/admin/member/add`,
        method: "POST",
      };
    },

    get deleteAmenityByGroupId() {
      return {
        url: `${API_URL}/admin/group/deleteamenity/`,
        method: "DELETE",
      };
    },

    get deletePackageById() {
      return {
        url: `${API_URL}/admin/package/deletepackage/`,
        method: "DELETE",
      };
    },

    get updatePackageById() {
      return {
        url: `${API_URL}/admin/package/updatepackage`,
        method: "PUT",
      };
    },

    get updateAmenityByGroupId() {
      return {
        url: `${API_URL}/admin/group/updateamenity`,
        method: "PUT",
      };
    },

    get updateMember() {
      return {
        url: `${API_URL}/admin/member/update`,
        method: "PUT",
      };
    },

    get updateNonMember() {
      return {
        url: `${API_URL}/admin/nonmember/update`,
        method: "PUT",
      };
    },

    get cancelMembership() {
      return {
        url: `${API_URL}/admin/cancelmemberpackagesubscription/`,
        method: "POST",
      };
    },

    get extendMembership() {
      return {
        url: `${API_URL}/admin/extendmemberpackagesubscription/`,
        method: "POST",
      };
    },

    get syncMembersData() {
      return {
        url: `${API_URL}/admin/syncrentmanagertenants`,
        method: "POST",
      };
    },

    get retryPaymentMembership() {
      return {
        url: `${API_URL}/admin/retrypayment/`,
        method: "POST",
      };
    },

    get deleteMember() {
      return {
        url: `${API_URL}/admin/deletemember/`,
        method: "DELETE",
      };
    },

    get getAllLockProviders() {
      return {
        url: `${API_URL}/admin/lockprovider/getall`,
        method: "GET",
      };
    },

    get createBuilding() {
      return {
        url: `${API_URL}/admin/buildings/createbuilding`,
        method: "POST",
      };
    },

    get getBuildingById() {
      return {
        url: `${API_URL}/admin/buildings/`,
        method: "GET",
      };
    },

    get updateBuilding() {
      return {
        url: `${API_URL}/admin/buildings/updatebuilding`,
        method: "PUT",
      };
    },

    get getAmenitiesByGroupId() {
      return {
        url: `${API_URL}/admin/group/getamenitiesbygroup?groupId=`,
        method: "GET",
      };
    },

    get getPackagesByGroupId() {
      return {
        url: `${API_URL}/admin/package/allpackagesbygroupid/`,
        method: "GET",
      };
    },

    get getAllAmenitiesRateTypes() {
      return {
        url: `${API_URL}/admin/ratetype/getall`,
        method: "GET",
      };
    },

    get getAllAmenityTypes() {
      return {
        url: `${API_URL}/admin/amenitytype/getall`,
        method: "GET",
      };
    },

    get addAmenityByGroupId() {
      return {
        url: `${API_URL}/admin/group/addamenity`,
        method: "POST",
      };
    },

    get getAllCoupons() {
      return {
        url: `${API_URL}/admin/voucher/getallvouchers`,
        method: "GET",
      };
    },

    get getAllNotifications() {
      return {
        url: `${API_URL}/admin/notification/getallnotifications`,
        method: "GET",
      };
    },

    get getAllUserNotifications() {
      return {
        url: `${API_URL}/notification/getmynotifications`,
        method: "GET",
      };
    },

    get markAsReadNotification() {
      return {
        url: `${API_URL}/notification/markseen`,
        method: "PUT",
      };
    },

    get getNotificationById() {
      return {
        url: `${API_URL}/admin/notification/getnotificationbyid/`,
        method: "GET",
      };
    },

    get addNotification() {
      return {
        url: `${API_URL}/admin/notification/addnotification`,
        method: "POST",
      };
    },

    get publishNotification() {
      return {
        url: `${API_URL}/admin/notification/updatemessagesent`,
        method: "PUT",
      };
    },

    get updateNotification() {
      return {
        url: `${API_URL}/admin/notification/updatenotification`,
        method: "PUT",
      };
    },

    get deleteNotificationById() {
      return {
        url: `${API_URL}/admin/notification/deletenotification/`,
        method: "DELETE",
      };
    },

    get addCoupon() {
      return {
        url: `${API_URL}/admin/voucher/addvoucher`,
        method: "POST",
      };
    },

    get getCouponById() {
      return {
        url: `${API_URL}/admin/voucher/getvoucherbyid/`,
        method: "GET",
      };
    },

    get updateCouponById() {
      return {
        url: `${API_URL}/admin/voucher/updatevoucher`,
        method: "PUT",
      };
    },

    get inactiveCoupon() {
      return {
        url: `${API_URL}/admin/voucher/inactivevoucher/`,
        method: "PUT",
      };
    },

    get addPackageByGroupId() {
      return {
        url: `${API_URL}/admin/package/createpackage`,
        method: "POST",
      };
    },

    get uploadMembers() {
      return {
        url: `${API_URL}/admin/buildings/uploadmembercsv`,
        method: "POST",
      };
    },

    get uploadExistingMembers() {
      return {
        url: `${API_URL}/admin/buildings/importexistingmembers`,
        method: "POST",
      };
    },

    get addUser() {
      return {
        url: `${API_URL}/admin/createuser`,
        method: "POST",
      };
    },

    get editUser() {
      return {
        url: `${API_URL}/admin/updateusers`,
        method: "PUT",
      };
    },

    get deleteUser() {
      return {
        url: `${API_URL}/admin/deleteuser/`,
        method: "DELETE",
      };
    },

    get deleteBuilding() {
      return {
        url: `${API_URL}/admin/buildings/deletebuilding/`,
        method: "DELETE",
      };
    },

    get getUserById() {
      return {
        url: `${API_URL}/admin/users/`,
        method: "GET",
      };
    },
    get getMembersByBuildingId() {
      return {
        url: `${API_URL}/admin/buildings/members`,
        method: "GET",
      };
    },
    get getAllRoles() {
      return {
        url: `${API_URL}/admin/role/getallroles`,
        method: "GET",
      };
    },

    get getAllRolesWithPermissions() {
      return {
        url: `${API_URL}/admin/role/getallroleswithpermissions`,
        method: "GET",
      };
    },

    get getRoleByIdWithPermissions() {
      return {
        url: `${API_URL}/admin/role/getrolewithpermissions/`,
        method: "GET",
      };
    },
    get getAllPermissions() {
      return {
        url: `${API_URL}/admin/permission/getallpermissions`,
        method: "GET",
      };
    },

    get addRoleWithPermissions() {
      return {
        url: `${API_URL}/admin/role/addrolewithpermissions`,
        method: "POST",
      };
    },
    get updateRoleWithPermissions() {
      return {
        url: `${API_URL}/admin/role/updaterolewithpermissions`,
        method: "PUT",
      };
    },

    get validateToken() {
      return {
        url: `${API_URL}/admin/validatetoken`,
        method: "GET",
      };
    },

    get getAllAssets() {
      return {
        url: `${API_URL}/admin/assets/getall`,
        method: "GET",
      };
    },

    get getAllAssetsTypes() {
      return {
        url: `${API_URL}/admin/assets/assettypes/getall`,
        method: "GET",
      };
    },

    get getAssetTypeById() {
      return {
        url: `${API_URL}/admin/assets/assettypes/`,
        method: "GET",
      };
    },

    get getAllParentAssetTypes() {
      return {
        url: `${API_URL}/admin/assets/assettypes/getallassetparentstypes`,
        method: "GET",
      };
    },

    get getAllSubAssetTypesByParentId() {
      return {
        url: `${API_URL}/admin/assets/assettypes/getallsubassettypesbyparentid/`,
        method: "GET",
      };
    },

    get addAssetType() {
      return {
        url: `${API_URL}/admin/assets/assettypes/add`,
        method: "POST",
      };
    },

    get addAsset() {
      return {
        url: `${API_URL}/admin/assets/addasset`,
        method: "POST",
      };
    },

    get updateAssetType() {
      return {
        url: `${API_URL}/admin/assets/assettypes/update`,
        method: "PUT",
      };
    },

    get deleteAssetType() {
      return {
        url: `${API_URL}/admin/assets/assettypes/delete/`,
        method: "DELETE",
      };
    },

    get updateAsset() {
      return {
        url: `${API_URL}/admin/assets/updateasset`,
        method: "PUT",
      };
    },

    get getAssetById() {
      return {
        url: `${API_URL}/admin/assets/getasset/`,
        method: "GET",
      };
    },

    get deleteAsset() {
      return {
        url: `${API_URL}/admin/assets/deleteasset/`,
        method: "DELETE",
      };
    },

    get adminComplaints() {
      return {
        url: `${API_URL}/admin/assetamenityticketadmin/get`,
        method: "GET",
      };
    },

    get changeComplaintStatus() {
      return {
        url: `${API_URL}/admin/assetamenityticketadmin/changestatustosolved/`,
        method: "PUT",
      };
    },

    get getallMemberViolations() {
      return {
        url: `${API_URL}/admin/memberviolation/getallmemberviolations`,
        method: "GET",
      };
    },

    get resetViolation() {
      return {
        url: `${API_URL}/admin/memberviolation/reset/`,
        method: "PUT",
      };
    },

    get deleteViolation() {
      return {
        url: `${API_URL}/admin/memberviolation/deletememberviolation/`,
        method: "DELETE",
      };
    },

    get getViolationsByMemberId() {
      return {
        url: `${API_URL}/admin/memberviolation/getmemberviolationsbymemberid/`,
        method: "GET",
      };
    },

    get addMemberViolation() {
      return {
        url: `${API_URL}/admin/memberviolation/addmemberviolation`,
        method: "POST",
      };
    },

    get updateMemberViolation() {
      return {
        url: `${API_URL}/admin/memberviolation/updatememberviolation`,
        method: "PUT",
      };
    },
  },
};

export default API;
